import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useUserInfo } from '../../../auth/hooks/useUserInfo';
import formatName from 'I18n/utils/formatName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AvailabilityIndicator from '../AvailabilityIndicator';
import { CapacitySection } from './CapacitySection';
import { PopoverActionButton } from './PopoverActionButton';
import { Avatar } from 'avatar-components/Avatar';
import http from 'conversations-http/clients/http';
import { Link } from 'foundations-components/transitional/components/Link';
import { getUserWorkingHoursURL } from '../../../working-hours/utils/workingHoursUtils';
import { linkToUsersAndTeamSettings } from '../../../urls/linkToUsersAndTeamSettings';
import { OutOfOfficeDetails } from '../StatusMessage/OutOfOfficeLabel';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PopoverMenuItem = ({
  isLast = false,
  padding,
  children
}) => {
  const borderStyle = !isLast && {
    borderBlockEndColor: 'border-core-subtle',
    borderBlockEndStyle: 'solid',
    borderBlockEndWidth: '100'
  };
  return /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsx(View, Object.assign({
      paddingInline: "500",
      paddingBlock: "300",
      padding: padding
    }, borderStyle, {
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        children: children
      })
    }))
  });
};
PopoverMenuItem.displayName = 'PopoverMenuItem';
export const AvailabilityPopover = ({
  isAway,
  onAwayModeToggle,
  capacity,
  currentSegment
}) => {
  const user = useUserInfo();
  const fullName = formatName({
    firstName: user === null || user === void 0 ? void 0 : user.user.first_name,
    lastName: user === null || user === void 0 ? void 0 : user.user.last_name
  });
  const isOOO = !!currentSegment;
  return /*#__PURE__*/_jsxs(List, {
    children: [/*#__PURE__*/_jsx(PopoverMenuItem, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        children: [/*#__PURE__*/_jsx(View, {
          paddingInlineEnd: "200",
          children: /*#__PURE__*/_jsx(Avatar, {
            size: "sm",
            hubSpotUserEmail: user === null || user === void 0 ? void 0 : user.user.email,
            fetchAvatars: (url, data) => {
              return http.post(url, {
                data
              });
            }
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h6",
            typography: "heading-50",
            children: fullName
          }), isOOO && /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(Flex, {
              children: /*#__PURE__*/_jsx(OutOfOfficeDetails, {
                startTimestamp: currentSegment.startTimestamp,
                endTimestamp: currentSegment.endTimestamp
              })
            })
          }), !isOOO && capacity && /*#__PURE__*/_jsx(CapacitySection, {
            userCapacity: capacity
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs(PopoverMenuItem, {
      padding: "0",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "small",
        paddingInline: "500",
        paddingBlockStart: "300",
        paddingBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.automateStatus.header"
        })
      }), /*#__PURE__*/_jsx(Link, {
        flexWrap: "nowrap",
        use: "unstyled",
        href: user ? getUserWorkingHoursURL(user.user.user_id) : linkToUsersAndTeamSettings(),
        children: /*#__PURE__*/_jsx(PopoverActionButton, {
          role: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.statusPopover.automateStatus.actionLink"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(PopoverMenuItem, {
      padding: "0",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "small",
        paddingInline: "500",
        paddingBlockStart: "300",
        paddingBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.updateStatus.header"
        })
      }), /*#__PURE__*/_jsx(PopoverActionButton, {
        onClick: onAwayModeToggle,
        "data-test-id": "availability-toggle-button",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
            atCapacity: false,
            isAwayMode: !isAway
          }), isAway ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.statusPopover.updateStatus.actionButtonAvailable"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.statusPopover.updateStatus.actionButtonAway"
          })]
        })
      })]
    })]
  });
};
AvailabilityPopover.displayName = 'AvailabilityPopover';